import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import { version } from '../../../package.json'

class AboutWindow extends Component {
    constructor(props) {
        super(props);

        this.position = {top: 100, left: 100}
        this.width = 200;

        this.position.left = window.innerWidth / 2 - this.width / 2;
        this.position.top = window.innerHeight / 2 - 100;
    }

    render() {
        const { toggle_about_window_visibility, toggle_donate_window_visibility } = this.props.StatisticActions;
        
        return (<PopupWindow header="2D ТВ" show_cut_down={false} width={this.width} top={this.position.top}  left={this.position.left} onClose={() => toggle_about_window_visibility()}>
                    <div>Версия: {version}</div>
                    <div><br/></div>
                    <div>Горячие клавиши:</div>
                    <table className="players_stats_table">
                        <tr>
                            <td>Пробел</td><td>Старт/Пауза</td>
                        </tr>
                        <tr>
                            <td>R</td><td>Повтор</td>
                        </tr>
                        <tr>
                            <td>Влево</td><td>-1 минута</td>
                        </tr>
                        <tr>
                            <td>Вправо</td><td>+1 минута</td>
                        </tr>
                    </table>
                    <div><br/></div>
                    <div> 
                        <button type="button" onClick={() => toggle_donate_window_visibility()} className="btn btn-sm donate btn-warning">
                            <span className="glyphicon glyphicon-ruble"></span> Поддержать
                        </button>
                    </div>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AboutWindow)



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/AboutWindow.js
 **/